import Future from 'src/utils/Future'
import { CampaignFragment } from 'src/graphql'

// Campaign Context
const CAMPAIGN_CONTEXT = 'CAMPAIGN_CONTEXT'
type CampaignContext = {
  kind: typeof CAMPAIGN_CONTEXT
  campaignId: string
  line?: number
}
const CampaignContext = (
  campaignId: string,
  line?: number,
): CampaignContext => ({
  kind: CAMPAIGN_CONTEXT,
  campaignId,
  line,
})

// Order Context
const ORDER_CONTEXT = 'ORDER_CONTEXT'
type OrderContext = {
  kind: typeof ORDER_CONTEXT
}
const OrderContext = (): OrderContext => ({
  kind: ORDER_CONTEXT,
})

// No Context
const NO_CONTEXT = 'NO_CONTEXT'
export type NoContext = {
  kind: typeof NO_CONTEXT
}
export const NoContext = (): NoContext => ({ kind: NO_CONTEXT })

export type ContextState = CampaignContext | OrderContext | NoContext

export type Context =
  | (CampaignContext & { campaign: Future<CampaignFragment> })
  | OrderContext
  | NoContext
